import { ColDef, GridOptions } from "@ag-grid-community/core";
import { Auth, Connect } from '@genesislcap/foundation-comms';
import { customElement, GenesisElement, observable, attr, volatile } from "@genesislcap/web-core";
import { columnDefs } from './watchlist-bonds.column.defs';
import { WatchlistBondsManagerStyles as styles } from './watchlist-bonds.styles';
import { WatchlistBondsTemplate as template } from './watchlist-bonds.template';
import { DatasourceConfiguration } from "@genesislcap/foundation-entity-management";
import { createFormSchema } from './watchlist-bonds.create.form.schema';
import { updateFormSchema } from './watchlist-bonds.update.form.schema';

@customElement({
  name: 'app-management-watchlist-bonds-manager',
  template,
  styles,
})
export class AppManagementWatchlistBondsManager extends GenesisElement {
  @Connect connect!: Connect;
  @Auth auth!: Auth;
  @attr watchListSelectedBonds: any[] = [];
  @attr criteria: string = '';

  @observable columns: ColDef[] = [...columnDefs];
  @observable createFormUiSchema = createFormSchema;
  @observable updateFormUiSchema = updateFormSchema;

  @volatile
  get datasourceConfig(): DatasourceConfiguration {
    return {
      maxRows: 250,
      maxView: 1000,
      criteria: `USER_NAME == '${this.auth.currentUser.userName}'`,
    };
  } 

  watchListSelectedBondsChanged() {
    if (this.watchListSelectedBonds.length > 0) {
      this.watchListSelectedBonds.forEach(bond => {
        this.connect.commitEvent('EVENT_WATCHLIST_BONDS_UPSERT', {
          DETAILS: {
            CUSIP: bond.CUSIP,
          },
          IGNORE_WARNINGS: true,
          VALIDATE: false,
        });
      });
    }
  }

  onCsvDataImported(event: CustomEvent) {
    const rowData = event.detail;
    rowData.forEach(bond => {
      this.connect.commitEvent('EVENT_WATCHLIST_BONDS_UPSERT', {
        DETAILS: {
          CUSIP: bond.CUSIP,
        },
        IGNORE_WARNINGS: true,
        VALIDATE: false,
      });
    });
  }
}
